import {Action} from '../interface/action';
export class ModuleAction implements Action{
     constructor(public ActionId : number,public ActionName : string, public ModuleId : number,public IsView : boolean,public IsAdd : boolean,public IsEdit : boolean,public IsDelete : boolean ){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/module-action.ts